export const baseUrl = process.env.BASE_URL!;

